export const skillsData = [
    {
        label: "FRONT END",
        data: [
            {
                skillName: "HTML",
                percentage: "80",
            },
            {
                skillName: "CSS",
                percentage: "80",
            },
            {
                skillName: "JAVASCRIPT",
                percentage: "80",
            },
            {
                skillName: "REACT JS",
                percentage: "90",
            },
            {
                skillName: "TAILWIND",
                percentage: "60",
            },
            {
                skillName: "TYPESCRIPT",
                percentage: "40",
            },

        ],
    },
    {
        label: "BACK END",
        data: [
            {
                skillName: "JAVA",
                percentage: "90",
            },
            {
                skillName: "PYTHON",
                percentage: "90",
            },
            {
                skillName: "C#",
                percentage: "40",
            },
            {
                skillName: "NODE JS",
                percentage: "90",
            },
        ]
    },
    {
        label: "DATABASES",
        data: [
            {
                skillName: "MYSQL",
                percentage: "90",
            },
            {
                skillName: "MONGODB",
                percentage: "80",
            },
            {
                skillName: "ORACLE",
                percentage: "70",
            },
            {
                skillName: "DOCKER",
                percentage: "40",
            },
            {
                skillName: "AWS",
                percentage: "50",
            },
        ]
    },
    {
        label: "Software",
        data: [
            {
                skillName: "DSA",
                percentage: "90",
            },
            {
                skillName: "C++",
                percentage: "90",
            },
            {
                skillName: "C",
                percentage: "70",
            },
        ]
    }


]

